module.exports = __webpack_public_path__ + "images/894e0b211c78cca65f93257d94dae66e-stayingLogo.png";